import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
export function MechanismSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full py-24 sm:py-32" style={{
    backgroundColor: '#111118'
  }} data-id="element-111">
      <div className="max-w-7xl mx-auto px-5 sm:px-8" data-id="element-112">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-113">
          {/* Image Column */}
          <motion.div initial={{
          opacity: 0,
          x: -40
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.7,
          ease: 'easeOut'
        }} className="flex justify-center lg:justify-start" data-id="element-114">
            <div className="relative" data-id="element-115">
              <div className="absolute -inset-6 rounded-3xl blur-3xl opacity-15 pointer-events-none" style={{
              backgroundColor: '#f97316'
            }} data-id="element-116" />
              <img src="https://cdn.magicpatterns.com/uploads/vz3rWLMLuzTftqXxea78BC/heylloyd-image-1771385681895.png" alt="Meeting Mercenary Protocol displayed on laptop and phone devices" className="relative rounded-2xl shadow-2xl w-full max-w-lg object-cover" data-id="element-117" />
            </div>
          </motion.div>

          {/* Text Column */}
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.15,
          ease: 'easeOut'
        }} data-id="element-118">
            <p className="text-xs font-semibold tracking-[0.25em] uppercase mb-4" style={{
            color: '#f97316'
          }} data-id="element-119">
              The Solution
            </p>

            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight leading-tight text-white mb-4" data-id="element-120">
              The Meeting Mercenary Protocol
            </h2>

            <p className="text-xl font-medium mb-6" style={{
            color: '#d4d4d8'
          }} data-id="element-121">
              Not a time-management philosophy.{' '}
              <span className="text-white font-bold" data-id="element-122">
                A Tactical Swipe File.
              </span>
            </p>

            <p className="text-lg leading-relaxed" style={{
            color: '#a1a1aa'
          }} data-id="element-123">
              25 "socially-safe" exit scripts and pre-meeting filters designed
              to protect your time like a finite currency.{' '}
              <span className="font-semibold text-white" data-id="element-124">
                Copy. Paste. Escape.
              </span>
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}